import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Col, Row } from 'reactstrap';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import Helper from '../../utilities/helper';
import { ErrorPage } from '../Shared/ErrorPage';
import { Hero } from "../Shared/Hero";
import { Loading } from '../Shared/Loading';
import { MetaTags } from '../Shared/MetaTags';
import { NavigationCardSet } from '../Shared/NavigationCards/NavigationCardSet';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { Benefits } from './Benefits';
import { CaseStudies } from './CaseStudies';
import { ExampleFundingSources } from './ExampleFundingSources';
import { ProjectSummary } from './ProjectSummary';
import { Testimonial } from './Testimonial';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';


const CMS_QUERY = `query datoQuery {
    pageData: pageProgramOverview {
        fieldHeroTitle
        fieldHeroStatement
        fieldProgramSteps {
            fieldStepColor
            fieldStepText
            fieldStepImage {
                alt
                url
                title
            }
        }
        fieldHowItWorksSectionTitle
        fieldDisplayTestimonialSection
        fieldTestimonial {
            fieldQuote
            fieldName
            fieldRole
            fieldOrganizationName
        }
        fieldDisplayCaseStudiesSection
        fieldCaseStudiesSectionTitle
        fieldCaseStudyLeft {
            fieldImage {
                url
                alt
                title
                focalPoint {
                    x
                    y
                }
            }
            fieldTitle
            fieldBodyText
            fieldUrl
        }
        fieldCaseStudyRight {
            fieldImage {
                url
                alt
                title
                focalPoint {
                    x
                    y
                }
            }
            fieldTitle
            fieldBodyText
            fieldUrl
        }
        fieldAdditionalServicesSectionTitle
        fieldAdditionalServices {
            fieldAdditionalServiceCaption
            fieldAdditionalServiceImage {
                url
                alt
                title
            }
        }
        fieldFundingSectionTitle
        fieldFundingBodyContent1
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export const ProgramOverview = () => {

    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const location = useLocation();

    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    // check for no errors
    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.ProgramOverview}>
                <div className="programOverview">
                <Hero pageTitle={data.pageData.fieldHeroTitle} pageStatement={data.pageData.fieldHeroStatement} />
                    <div>
                        <ProjectSummary fieldHowItWorksSectionTitle={data.pageData.fieldHowItWorksSectionTitle} fieldProgramSteps={data.pageData.fieldProgramSteps} />
                    </div>
                    <div>
                        {data.pageData.fieldDisplayTestimonialSection && <Testimonial fieldTestimonial={data.pageData.fieldTestimonial} key="testimonials" />}
                        {data.pageData.fieldDisplayCaseStudiesSection && <CaseStudies fieldCaseStudiesSectionTitle={data.pageData.fieldCaseStudiesSectionTitle} fieldCaseStudyLeft={data.pageData.fieldCaseStudyLeft} fieldCaseStudyRight={data.pageData.fieldCaseStudyRight} key="casestudies"/>}
                    </div>

                    <div>
                        <Benefits fieldAdditionalServicesSectionTitle={data.pageData.fieldAdditionalServicesSectionTitle} fieldAdditionalServicesData={data.pageData.fieldAdditionalServices} key="benefits"/>
                    </div>
                    <div>
                        <ExampleFundingSources sectionTitle={data.pageData.fieldFundingSectionTitle} sectionDescription={data.pageData.fieldFundingBodyContent1} key="fundingSourcesTable" />
                    </div>
                <NavigationCardSet PageData={data.pageData} />
                <MetaTags seoData={data.pageData.seo} />
                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
